export default{
    namespaced: true,

    state:{
        dietaConsistenciaItems:[
            {value:"liquida", text:"Dieta líquida"},
            {value:"blanda", text:"Dieta blanda"},
            {value:"normal", text:"Dieta normal"},
        ],
        dietaEspecificaItems:[
            {value:"normal", text:"Normal"},
            {value:"nefro", text:"Nefrópata"},
            {value:"diabe", text:"Diabética"},
            {value:"cardio", text:"Cardiópata"},
            {value:"hipercal", text:"Hipercalórica"},
            {value:"hipocal", text:"Hipocalórica"},
            {value:"hiperprot", text:"Hiperprotética"},
            {value:"hipoprot", text:"Hipoprotética"},
            {value:"hiposodica", text:"Hiposódica"},
            {value:"otra", text:"Otra"},
        ],
        tiposDietaExternos:[
            {value:1, text:"Trabajador"},
            {value:2, text:"Personal de Cirugía"},
            {value:3, text:"Comensal externo"},
        ],
    },
}